<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
            <div class="card-header">
                <div class="d-md-flex align-items-center">
                    <div>
                        <h4 class="card-title mdi mdi-wallet-membership"> Membership Plan: {{plan.name}}</h4>
                        <h6 class="card-subtitle">Plan details</h6>
                    </div>
                    <div class="ml-auto d-flex no-block align-items-center">
                        <div class="dl">
                            <div class="button-group">
                                <router-link :to="{name: 'plans'}" class="btn btn-outline-secondary waves-effect waves-light"><i class="fas fa-arrow-circle-left"></i> Back</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body card-blue">
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Name:</label>
                    <div class="col-md-9">
                        <p class="form-control-static"> {{plan.name}} </p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Description:</label>
                    <div class="col-md-9">
                        <p class="form-control-static"> {{plan.description}} </p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Status:</label>
                    <div class="col-md-9">
                        <p class="form-control-static">
                            <span class="label label-info" v-if="plan.status === 'READY'">READY</span>
                            <span class="label label-dark-green" v-if="plan.status === 'ACTIVE'">ACTIVE</span>
                            <span class="label label-grey" v-if="plan.status === 'RETIRED'">RETIRED</span>
                        </p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Fee:</label>
                    <div class="col-md-9">
                        <p class="form-control-static"> {{plan.fee?plan.fee:0 | currency(plan.currency)}}</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Schedule:</label>
                    <div class="col-md-9">
                        <p class="form-control-static"> {{plan.schedule}}</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Created On:</label>
                    <div class="col-md-9">
                        <p class="form-control-static"> {{plan.created_at| long}}</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Active From:</label>
                    <div class="col-md-9">
                        <p class="form-control-static" v-if="plan.active_at"> {{plan.active_at| long}}</p>
                        <p class="form-control-static" v-if="!plan.active_at"> N/A</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Retired On:</label>
                    <div class="col-md-9">
                        <p class="form-control-static" v-if="plan.retire_at"> {{plan.retire_at| long}}</p>
                        <p class="form-control-static" v-if="!plan.retire_at"> N/A</p>
                    </div>
                </div>
            </div>
            <div class="card-footer" style="min-height: 60px;">
                <div class="row">
                    <div class="col-md-12 text-right">
                        <button @click="activatePlan()" class="btn waves-effect waves-light btn-success m-r-5" type="button" v-if="plan.status === 'READY'">
                            <i class="fas fa-play"></i> &nbsp;Activate
                        </button>
                        <button @click="openRetireModal()" class="btn waves-effect waves-light btn-danger m-r-5" data-target="#retireModal" data-toggle="modal" type="button"
                                v-if="plan.status === 'ACTIVE'">
                            <i class="fas fa-pause"></i> &nbsp;Retire
                        </button>
                        <div aria-hidden="true" aria-labelledby="retireModal" class="modal fade" id="retireModal" role="dialog" tabindex="-1">
                            <div class="modal-dialog">
                                <div class="modal-content text-left">
                                    <div class="modal-body p-0">
                                        <div class="card card-blue m-b-0">
                                            <div class="card-header">
                                                <h4 class="card-title">Retire Plan: {{plan.name}}</h4>
                                                <h6 class="card-subtitle">Select a new plan to continue</h6>
                                            </div>
                                            <form @submit.prevent="handleRetireSubmit('retire-form')" class="form-horizontal" data-vv-scope="retire-form">
                                                <div class="card-body">
                                                    <div class="form-group row">
                                                        <label class="control-label text-right col-md-3">New Plan:</label>
                                                        <div class="col-md-9">
                                                            <multiselect :class="{'is-invalid': submitted && errors.has('retire-form.new_plan')}"
                                                                         :clear-on-select="false"
                                                                         :close-on-select="true"
                                                                         :hide-selected="true"
                                                                         :internal-search="false"
                                                                         :limit="3"
                                                                         :loading="isLoading"
                                                                         :max-height="600"
                                                                         :options="plans"
                                                                         :options-limit="300"
                                                                         :searchable="true"
                                                                         :show-no-results="false"
                                                                         @search-change="getPlans"
                                                                         class="form-control"
                                                                         data-vv-as="New Plan"
                                                                         id="new_plan"
                                                                         label="text"
                                                                         name="new_plan"
                                                                         open-direction="bottom"
                                                                         placeholder="Select New Plan"
                                                                         selectLabel=""
                                                                         v-model="new_plan"
                                                                         v-validate="'required'">
                                                                <template slot="singleLabel" slot-scope="props">
                                                                    <div class="option__desc">
                                                                        <div class="option__desc">
                                                                            <h4>{{ props.option.name }}</h4>
                                                                            <h6>{{ props.option.status }}</h6>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                                <template slot="option" slot-scope="props">
                                                                    <div class="option__desc">
                                                                        <div class="option__desc">
                                                                            <h4>{{ props.option.name }}</h4>
                                                                            <h6>{{ props.option.status }}</h6>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </multiselect>
                                                            <div class="invalid-feedback" v-if="submitted && errors.has('retire-form.new_plan')">{{ errors.first('retire-form.new_plan') }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer text-right">
                                                    <button class="btn waves-effect waves-light btn-success m-r-15" type="submit">Submit</button>
                                                    <button class="btn waves-effect waves-light btn-secondary" data-dismiss="modal" type="button">Cancel</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <div class="d-md-flex align-items-center">
                    <div>
                        <h4 class="card-title mdi mdi-account-multiple"> Members</h4>
                        <h6 class="card-subtitle">Add / Remove members</h6>
                    </div>

                    <div class="ml-auto d-flex no-block align-items-center">
                        <div class="dl">
                            <div class="button-group">
                                <button @click="openAddMemberModal()" class="btn waves-effect waves-light btn-success" data-target="#addMemberModal" data-toggle="modal" type="button"
                                        v-if="plan.status == 'ACTIVE'"><i
                                        class="fas fa-user-plus"></i> &nbsp;Add Member
                                </button>
                                <div aria-hidden="true" aria-labelledby="addMemberModal" class="modal fade" id="addMemberModal" role="dialog" tabindex="-1">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content text-left">
                                            <div class="modal-body p-0">
                                                <div class="card card-blue m-b-0">
                                                    <div class="card-header">
                                                        <h4 class="card-title">Retire Plan: {{plan.name}}</h4>
                                                        <h6 class="card-subtitle">Select a new plan to continue</h6>
                                                    </div>
                                                    <form @submit.prevent="handleMembersSubmit('members-form')" class="form-horizontal" data-vv-scope="members-form">
                                                        <div class="card-body">
                                                            <div class="form-group row">
                                                                <label class="control-label text-right col-md-3" for="growers">Select Members:</label>
                                                                <div class="col-md-9">
                                                                    <multiselect
                                                                            :class="{'is-invalid': submitted && errors.has('members-form.members')}"
                                                                            :clear-on-select="false"
                                                                            :close-on-select="false"
                                                                            :hide-selected="true"
                                                                            :internal-search="false"
                                                                            :limit="5"
                                                                            :limit-text="limitText"
                                                                            :loading="isLoading"
                                                                            :max-height="600"
                                                                            :multiple="true"
                                                                            :options="growers"
                                                                            :options-limit="300"
                                                                            :searchable="true"
                                                                            :show-no-results="false"
                                                                            @search-change="getGrowers"
                                                                            class="form-control"
                                                                            id="growers"
                                                                            label="name"
                                                                            name="growers"
                                                                            open-direction="bottom"
                                                                            placeholder="Search growers"
                                                                            track-by="id"
                                                                            v-model="newMembers"
                                                                            v-validate="'required'">
                                                                        <template slot="singleLabel" slot-scope="props">
                                                                            <div class="option__desc">
                                                                                <div class="option__desc">
                                                                                    <h4>{{ props.option.name }}</h4>
                                                                                    <h6>{{ props.option.status }}</h6>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                        <template slot="option" slot-scope="props">
                                                                            <div class="option__desc">
                                                                                <div class="option__desc">
                                                                                    <h4>{{ props.option.name }}</h4>
                                                                                    <h6>{{ props.option.status }}</h6>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    </multiselect>
                                                                    <div class="invalid-feedback" v-if="submitted && errors.has('members-form.members')">{{ errors.first('members-form.members') }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card-footer text-right">
                                                            <button class="btn waves-effect waves-light btn-success m-r-15" type="submit">Submit</button>
                                                            <button class="btn waves-effect waves-light btn-secondary" data-dismiss="modal" type="button">Cancel</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body card-blue">
                <ul class="nav nav-tabs customtab" role="tablist">
                    <li @click="tab('active')" class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#active" role="tab">
                            <span class="hidden-xs-down">Active Members</span>
                        </a>
                    </li>
                    <li @click="tab('history')" class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#history" role="tab">
                            <span class="hidden-xs-down">History</span>
                        </a>
                    </li>
                </ul>

                <!-- Tab panes -->
                <div class="tab-content" v-if="members.length>0">
                    <div class="tab-pane active" id="active" role="tabpanel">
                        <div class="table-responsive">
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0">Member</th>
                                    <th class="border-0">Status</th>
                                    <th class="border-0">Member Since</th>
                                    <th class="border-0">Member Till</th>
                                    <th class="border-0">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(member, index) in members">
                                    <td>{{member.biz_name}}</td>
                                    <td>
                                        <span class="label label-dark-green" v-if="member.status === 'ACTIVE'">{{member.status}}</span>
                                        <span class="label label-grey" v-if="member.status === 'INACTIVE'">{{member.status}}</span>
                                    </td>
                                    <td>{{member.begin | medium}}</td>
                                    <td>
                                        <template v-if="member.end">{{member.end| medium}}</template>
                                        <template v-if="!member.end">N/A</template>
                                    </td>
                                    <td>
                                        <a @click="selectMember(member)" class="text-danger" data-target="#confirmModal" data-toggle="modal" href="javasript:void(0);"
                                           v-if="member.status === 'ACTIVE'"><b>Remove</b></a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal" role="dialog" tabindex="-1">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-body card-blue">
                                            <div class="text-center m-t-20 m-b-10">
                                                <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                                                <br><br>
                                                <h4>Are you sure you want to remove {{member.biz_name}} from plan {{plan.name}}?</h4>
                                                <button @click="removeMember()" class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal" type="button">Yes</button>
                                                <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">No</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="history" role="tabpanel">
                        <div class="table-responsive">
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0">Member</th>
                                    <th class="border-0">Status</th>
                                    <th class="border-0">Member Since</th>
                                    <th class="border-0">Member Till</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(member, index) in members">
                                    <td>{{member.biz_name}}</td>
                                    <td>
                                        <span class="label label-dark-green" v-if="member.status === 'ACTIVE'">{{member.status}}</span>
                                        <span class="label label-grey" v-if="member.status === 'INACTIVE'">{{member.status}}</span>
                                    </td>
                                    <td>{{member.begin | medium}}</td>
                                    <td>
                                        <template v-if="member.end">{{member.end| medium}}</template>
                                        <template v-if="!member.end">N/A</template>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <paginate
                            :click-handler="pageHandler"
                            :container-class="'pagination float-right'"
                            :margin-pages="2"
                            :next-class="'page-link'"
                            :next-text="'Next'"
                            :page-class="'page-link'"
                            :page-count=pageCount
                            :page-range="3"
                            :prev-class="'page-link'"
                            :prev-text="'Prev'">
                    </paginate>
                </div>
                <div class="tab-content" v-else>
                    <h4 class="card-title text-muted text-center m-30">No records found</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import _ from 'lodash';
    import Multiselect from 'vue-multiselect';

    export default {
        name: "ViewMembershipPlan",
        props: ["planid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Paginate, Multiselect},
        data() {
            return {
                isLoading: false,
                submitted: false,
                plan: {
                    name: null,
                    description: null,
                    fee: null,
                    currency: null,
                },
                members: [],
                pageCount: 1,
                total: 0,
                member: {
                    id: null,
                    biz_name: null
                },
                activeTab: 'active',
                status: 'ACTIVE',
                plans: [],
                new_plan: null,
                growers: [],
                newMembers: []
            }
        },
        mounted() {
            this.getPlan();
            this.getPlanMembers(1);
        },
        methods: {
            async getPlan() {
                let reply = await this.$http.get(`marketplaces/${this.currentOrg.marketplace_id}/plans/${this.planid}`);
                this.plan = reply.data;
            },
            async getPlanMembers(pageNum) {
                let filter = {
                    page: pageNum,
                    perPage: 10
                };

                if(this.status) {
                    filter.status = this.status;
                }

                let reply = await this.$http.get(`marketplaces/${this.currentOrg.marketplace_id}/plans/${this.planid}/members`, {params: filter});

                this.total   = reply.data.total;
                this.members = reply.data.members;
                this.setPageCount();
            },
            selectMember(member) {
                this.member = member;
            },
            async removeMember() {
                try {
                    await this.$http.delete(`marketplaces/${this.currentOrg.marketplace_id}/plans/${this.planid}/members`, {data: {org_id: this.member.id}});
                    this.$toastr('success', `${this.member.biz_name} successfully removed`, 'Member Removed');
                    await this.getPlanMembers();
                } catch(e) {
                    this.$toastr('error', `Failed to remove ${this.member.biz_name}`, 'Failed');
                }
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            pageHandler(pageNum) {
                this.getPlanMembers(pageNum);
            },
            tab(tabName) {
                if(tabName === 'active') {
                    this.status = 'ACTIVE';
                } else {
                    this.status = null;
                }
                this.activeTab = tabName;
                this.getPlanMembers();
            },
            async activatePlan() {
                try {
                    let members = [];

                    this.newMembers.forEach(member => {
                        member.id
                    });

                    await this.$http.put(`marketplaces/${this.currentOrg.marketplace_id}/plans/${this.planid}/activate`, members);
                    this.$toastr('success', `Members successfully retired`, 'Success');
                    $('#addMemberModal').modal('hide');
                    await this.getPlan();
                    await this.getPlanMembers();
                } catch(e) {
                    this.$toastr('error', `Failed to Add member`, 'Failed');
                }
            },
            async retirePlan() {
                try {
                    await this.$http.post(`marketplaces/${this.currentOrg.marketplace_id}/plans/${this.planid}/retire`, {
                        planid: this.new_plan.id
                    });
                    this.$toastr('success', `Plan successfully retired`, 'Success');
                    $('#retireModal').modal('hide');
                    await this.getPlan();
                    await this.getPlanMembers();
                } catch(e) {
                    this.$toastr('error', `Failed to retire plan`, 'Failed');
                }
            },
            async handleRetireSubmit(scope) {
                this.submitted = true;
                this.$validator.validateAll(scope)
                .then(valid => {
                    if(valid) {
                        this.retirePlan();
                    }
                });
            },
            async getPlans(searchText) {
                let ref    = this;
                let reply  = await this.$http.get(`marketplaces/${this.currentOrg.marketplace_id}/plans/search`, {
                    params: {
                        search: searchText
                    }
                });
                this.plans = _.filter(reply.data, function(plan) {
                    return ((plan.status === 'READY' || plan.status === 'ACTIVE') && plan.id !== ref.plan.id)
                });
            },
            openRetireModal() {
                this.submitted = false;
                this.plans     = [];
                this.new_plan  = null;
            },
            async getGrowers(searchText) {
                this.isLoading = true;
                let reply      = await this.$http.get("/org/search", {
                    params: {
                        search: searchText,
                        orgtype: 'COOP_MEMBER',
                        orgstatus: 'INACTIVE'
                    }
                });
                this.growers   = reply.data;
                this.isLoading = false;
            },
            limitText(count) {
                return `and ${count} more users.`
            },
            handleMembersSubmit(scope) {
                this.submitted = true;
                this.$validator.validateAll(scope)
                .then(valid => {
                    if(valid) {
                        this.addMembers();
                    }
                });
            },
            async addMembers() {
                try {
                    let members = [];

                    // get ids
                    this.newMembers.forEach(member => {
                        // avoid duplicate
                        if(!members.includes(member.id)) {
                            members.push(member.id);
                        }
                    });

                    await this.$http.put(`marketplaces/${this.currentOrg.marketplace_id}/plans/${this.planid}/members`, members);
                    this.$toastr('success', `Members successfully added`, 'Success');
                    $('#addMemberModal').modal('hide');
                    await this.getPlan();
                    await this.getPlanMembers();
                } catch(e) {
                    this.$toastr('error', `Failed to add members`, 'Failed');
                }
            },
            openAddMemberModal() {
                this.submitted  = false;
                this.newMembers = [];
                this.growers    = [];
            }
        }
    }
</script>

<style scoped>

</style>